import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import act from '~/modules/master/redux/actions/report-business-travel-not-check-in'

const useReportBusinessTravelNotCheckIn = () => {
  const data = useSelector((state) => get(state, 'master.reportBusinessTravelNotCheckIn'))

  const dispatch = useDispatch()
  const actions = useMemo(() => bindActionCreators(act, dispatch), [dispatch])
  return {
    actions,
    data,
  }
}

export default useReportBusinessTravelNotCheckIn
